import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { usePageTracking } from './analytics/usePageTracking';
import LandingPage from './components/LandingPage';
import HomePage from './components/HomePage';
import RoomPage from './components/RoomPage';
import SingerPage from './components/SingerPage';

// Lazy-load heavy or secondary routes to keep the initial bundle small.
const BigPicture = lazy(() => import('./components/BigPicture'));
const FestivalPage = lazy(() => import('./components/FestivalPage'));
const FestivalMockPage = lazy(() => import('./components/FestivalMockPage'));
const FestivalEventPage = lazy(() => import('./components/FestivalEventPage'));
const MockFestivalEventPage = lazy(() => import('./components/MockFestivalEventPage'));
const VenuesPage = lazy(() => import('./components/VenuesPage'));
const VenuePage = lazy(() => import('./components/VenuePage'));
const VenuesMockPage = lazy(() => import('./components/VenuesMockPage'));
const MockVenuePage = lazy(() => import('./components/MockVenuePage'));
const CreateRoomPage = lazy(() => import('./components/CreateRoomPage'));
const JoinRoomPage = lazy(() => import('./components/JoinRoomPage'));
const CodeRedirectPage = lazy(() => import('./components/CodeRedirectPage'));
const TestRoomPage = lazy(() => import('./components/TestRoomPage'));
const SingerTestPage = lazy(() => import('./components/SingerTestPage'));
const TestStagePage = lazy(() => import('./components/TestStagePage'));
const TvPage = lazy(() => import('./components/TvPage'));
const PairPage = lazy(() => import('./components/PairPage'));
const ProfilePage = lazy(() => import('./components/ProfilePage'));
const MockProfilePage = lazy(() => import('./components/MockProfilePage'));
import AboutPage from './components/AboutPage';
import CmsPage from './components/CmsPage';
import CityVenuesPage from './components/CityVenuesPage';
const TestSearchSheetPage = lazy(() => import('./components/TestSearchSheetPage'));
// Confirmação de saída (Back na landing) para apps de TV empacotadas que
// apontam para o site principal — os bridges em /tv-bridges emitem
// karaokr:exit-request e este componente mostra o diálogo.
import ExitConfirm from './tv/ExitConfirm';

function BigPictureRedirect() {
  const { roomId } = useParams<{ roomId: string }>();
  return <Navigate to={`/stage/${roomId}`} replace />;
}

function FestivalRedirect() {
  return <Navigate to="/festival" replace />;
}

function App() {
  usePageTracking();
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/console" element={<HomePage />} />
        <Route path="/create-room" element={<CreateRoomPage />} />
        <Route path="/join-room" element={<JoinRoomPage />} />
        <Route path="/c/:code" element={<CodeRedirectPage />} />
        <Route path="/room/:roomId" element={<RoomPage />} />
        <Route path="/singer/:roomId" element={<SingerPage />} />
        <Route path="/test-room" element={<TestRoomPage />} />
        <Route path="/test-singer" element={<SingerTestPage />} />
        <Route path="/test-stage" element={<TestStagePage />} />
        <Route path="/stage/:roomId" element={<BigPicture />} />
        <Route path="/big-picture/:roomId" element={<BigPictureRedirect />} />
        <Route path="/tv" element={<TvPage />} />
        <Route path="/pair" element={<PairPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/mock-profile" element={<MockProfilePage />} />
        <Route path="/festival" element={<FestivalPage />} />
        <Route path="/festival/:id" element={<FestivalEventPage />} />
        <Route path="/venues" element={<VenuesPage />} />
        <Route path="/venues/:slug" element={<VenuePage />} />
        <Route path="/city/:citySlug" element={<CityVenuesPage />} />
        <Route path="/mock-venues" element={<VenuesMockPage />} />
        <Route path="/mock-venues/:slug" element={<MockVenuePage />} />
        <Route path="/mock-festival" element={<FestivalMockPage />} />
        <Route path="/mock-festival/:id" element={<MockFestivalEventPage />} />
        <Route path="/mock-venues" element={<VenuesMockPage />} />
        <Route path="/events" element={<FestivalRedirect />} />
        <Route path="/events/:id" element={<FestivalRedirect />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms" element={<CmsPage pageKey="terms" />} />
        <Route path="/privacy" element={<CmsPage pageKey="privacy" />} />
        <Route path="/test-searchsheet" element={<TestSearchSheetPage />} />
      </Routes>
      <ExitConfirm />
    </Suspense>
  );
}

export default App;
